import { styled } from "@mui/material/styles";
import { Typography, Button, Paper, Box } from "@mui/material";

export const PageTitle = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "28.18px",
  textAlign: "left",
  marginBottom: "20px",
  marginLeft: "12px",
  color: "#202224",
});

export const CreateButton = styled(Button)({
  color: "#4C679D",
  borderColor: "#4C679D",
  borderWidth: "2px",
  borderStyle: "solid",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  padding: "10px 30px",
});

export const JobBox = styled(Paper)({
  padding: "10px",
  marginBottom: "10px",
  borderRadius: "14px",
  backgroundColor: "#fff",
  boxShadow: "0px 3px 6px #00000029",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  position: "relative",
});

export const LogoContainer = styled(Box)({
  position: "absolute",
  top: "20px",
  left: "20px",
  height: "30px",
  zIndex: 1,
});

export const Logo = styled("img")({
  width: "80px",
  height: "auto",
});

export const JobDetails = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flex: 1,
  position: "relative",
});

export const JobDescription = styled(Typography)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
  lineHeight: "1.5",
});

export const InfoContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
});

export const BoxTitle = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "20px",
  fontWeight: 600,
  color: "#202224",
  lineHeight: "20px",
});

export const BoxCompany = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "16px",
  fontWeight: 400,
  color: "#767B81",
  lineHeight: "20px",
});

export const BoxDescription = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "16px",
  fontWeight: 500,
  color: "#202224",
  lineHeight: "20px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
  marginBottom: "auto",
});

export const BoxDate = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "16px",
  fontWeight: 600,
  color: "#767B81",
  lineHeight: "20px",
  display: "flex",
  alignItems: "center",
});

export const BoxLocation = styled(Typography)({
  fontFamily: "Raleway",
  fontSize: "16px",
  fontWeight: 600,
  color: "#767B81",
  lineHeight: "20px",
  display: "flex",
  alignItems: "center",
});

export const CenteredMessage = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "60vh",
  textAlign: "center",
  color: "#767B81",
  fontFamily: "Raleway",
  fontSize: "20px",
  fontWeight: 500,
});

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "30px",
  alignSelf: "center",
  borderRadius: "24px",
  width: "160px",
  height: "40px",
  background: "#F0FFFF",
  color: "black",
  // backgroundColor: theme.palette.primary.main,
  // color: "white",
  textTransform: "none",
  fontSize: "16px",
  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.25)",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
}));